import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const Wrapper = styled.div`
    padding: 24px;
    width: 240px;
  
    // Не получилось использовать ButtonGroup потому что там срабатывает @media (min-width: 767px) width: auto
    ${Button} {
        width: 100%;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: auto;
        padding: 0;
    }
`;

export const Info = styled.div`
    position: relative;
    padding-left: 28px;
    margin-bottom: 16px;
    white-space: pre-wrap;
    width: 100%;
    svg {
        position: absolute;
        left: 0;
        top: 0;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        white-space: normal;
    }
`;

export const SkeletonContainer = styled.div<{
    width: string,
    height: string,
    isLoading: boolean,
}>`
    width: ${({ width }) => width};
    height: ${({ height }) => height};
    display: ${({ isLoading }) => isLoading ? 'block' : 'none'};
    > span > span {
        margin-bottom: 0px;
    }

    @media (min-width: ${wideBreakpoints.laptop}) {
        > span > span {
            margin-bottom: 4px;
        }
    }
`;
